import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { getKey } from '../utils/uid';
import { menuClass } from './styles';
import Item from './Item';

var List =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(List, _PureComponent);

  var _super = _createSuper2(List);

  function List() {
    _classCallCheck(this, List);

    return _super.apply(this, arguments);
  }

  _createClass(List, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          path = _this$props.path,
          mode = _this$props.mode,
          style = _this$props.style,
          level = _this$props.level,
          keygen = _this$props.keygen,
          topLine = _this$props.topLine,
          onClick = _this$props.onClick,
          linkKey = _this$props.linkKey,
          disabled = _this$props.disabled,
          renderItem = _this$props.renderItem,
          frontCaret = _this$props.frontCaret,
          bottomLine = _this$props.bottomLine,
          caretColor = _this$props.caretColor,
          inlineIndent = _this$props.inlineIndent,
          looseChildren = _this$props.looseChildren,
          frontCaretType = _this$props.frontCaretType,
          toggleOpenKeys = _this$props.toggleOpenKeys,
          toggleDuration = _this$props.toggleDuration,
          parentSelectable = _this$props.parentSelectable;
      var isVertical = mode.indexOf('vertical') === 0;
      var className = classnames(menuClass('list', isVertical ? 'vertical' : mode), this.props.className);
      return (
        /*#__PURE__*/
        React.createElement("ul", {
          className: className,
          style: style
        }, data.map(function (d, i) {
          return (
            /*#__PURE__*/
            React.createElement(Item, {
              data: d,
              index: i,
              mode: mode,
              path: path,
              level: level,
              keygen: keygen,
              onClick: onClick,
              linkKey: linkKey,
              topLine: topLine,
              disabled: disabled,
              frontCaret: frontCaret,
              caretColor: caretColor,
              bottomLine: bottomLine,
              renderItem: renderItem,
              key: getKey(d, keygen, i),
              inlineIndent: inlineIndent,
              looseChildren: looseChildren,
              toggleOpenKeys: toggleOpenKeys,
              toggleDuration: toggleDuration,
              frontCaretType: frontCaretType,
              parentSelectable: parentSelectable
            })
          );
        }))
      );
    }
  }]);

  return List;
}(PureComponent);

export default List;